import { FC } from 'react'
import { IconProps } from '../../../LandingPage.icons'

const Circle: FC<IconProps> = ({
  className = '',
  svgClassName = '',
  height = 83,
  width = 102,
}) => (
  <span aria-label="Circle Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50.9839 82.704C79.1415 82.704 101.968 61.2799 101.968 34.852C101.968 8.42406 79.1415 -13 50.9839 -13C22.8263 -13 0 8.42406 0 34.852C0 61.2799 22.8263 82.704 50.9839 82.704Z" />
    </svg>
  </span>
)

export default Circle
